import { render } from "./StudyBasedUserList.vue?vue&type=template&id=91c29c98&scoped=true"
import script from "./StudyBasedUserList.vue?vue&type=script&lang=js"
export * from "./StudyBasedUserList.vue?vue&type=script&lang=js"

import "./StudyBasedUserList.vue?vue&type=style&index=0&id=91c29c98&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c29c98"]])

export default __exports__